import { defineStore } from 'pinia';

import { useHubspotStore } from '@/stores/hubspot';
import { useIntercomStore } from '@/stores/intercom';

export const useSupportChatStore = defineStore('supportChat', () => {
  const intercomStore = useIntercomStore();
  const hubspotStore = useHubspotStore();

  function show(...args) {
    if (hubspotStore.enabled) {
      hubspotStore.show(...args);
    } else {
      intercomStore.show(...args);
    }
  }

  return {
    show,
  };
});
